import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("ADMIN-1");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(username.trim(), password);
      toast.success("Welcome back");
      navigate("/");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-desktop">
      <form className="login-card" onSubmit={submit} data-testid="login-form">
        <div className="login-head">RETAIL LTD — POS LOGIN</div>
        <div className="login-body">
          <label className="login-label">User ID</label>
          <input
            className="pos-input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            data-testid="login-username"
            autoComplete="username"
          />
          <div style={{ height: 14 }} />
          <label className="login-label">Password</label>
          <input
            className="pos-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password"
            autoComplete="current-password"
          />
          <div style={{ height: 20 }} />
          <button
            type="submit"
            className="win-btn"
            style={{ width: "100%", height: 42, fontSize: 14 }}
            disabled={busy}
            data-testid="login-submit"
          >
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </div>
      </form>
    </div>
  );
}
